import { GeocodingLookupSchema, StartingPlaceResponseSchema } from '../../../shared/geocoding';
import { API, apiRequest, jsonPost } from './api-client';
import type { RidePoint } from '../domain/ride';

/** The authenticated API reuses permanent lookup results across projects. */
export async function lookupStartingPlace(point: Pick<RidePoint, 'latitude' | 'longitude'>, signal: AbortSignal) {
  try {
    signal.throwIfAborted();
    const query = GeocodingLookupSchema.parse({ latitude: point.latitude, longitude: point.longitude });
    const value = await apiRequest<unknown>(`${API}/studio/geocoding/reverse`, {
      ...jsonPost(query), signal: AbortSignal.any([signal, AbortSignal.timeout(12_000)]), cache: 'no-store',
    });
    const title = StartingPlaceResponseSchema.parse(value).place;
    if (!title) throw new Error('No place returned.');
    return title;
  } catch {
    // Keep dependency and authentication details out of the place-title controls.
    throw new Error('Starting location lookup is unavailable.');
  }
}
